<template>
  <!-- Variante larga: ocupa duas colunas, texto a esquerda e ilustracao a direita. -->
  <div
    v-if="wide"
    class="va-tile-wide"
    :class="{ 'va-tile-wide-banner': banner }"
    :style="{ gridColumn: `span ${span}` }"
    role="button"
    tabindex="0"
    :aria-label="label"
    @click="$emit('select', section)"
    @keydown.enter.prevent="$emit('select', section)"
    @keydown.space.prevent="$emit('select', section)"
  >
    <span class="va-tile-wide-label">{{ label }}</span>
    <img
      v-if="illustration && !illustrationFailed"
      class="va-tile-wide-art"
      :src="illustration"
      alt=""
      aria-hidden="true"
      @error="illustrationFailed = true"
    />
  </div>
  <div
    v-else
    class="va-tile"
    role="button"
    tabindex="0"
    :aria-label="label"
    @click="$emit('select', section)"
    @keydown.enter.prevent="$emit('select', section)"
    @keydown.space.prevent="$emit('select', section)"
  >
    <span class="va-tile-circle">
      <v-icon class="va-icon" size="24" color="primary">{{ _icon(section.icon) }}</v-icon>
      <span v-if="showPro" class="va-tile-pro"><vetalfa-pro-badge></vetalfa-pro-badge></span>
    </span>
    <span class="va-tile-label">{{ label }}</span>
  </div>
</template>

<style>
.va-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 0;
  cursor: pointer;
}

.va-tile-circle {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #f5f6fa;
  transition: background-color 0.15s ease;
}

.va-tile:hover .va-tile-circle {
  background: #eef0f5;
}

.va-tile-pro {
  position: absolute;
  top: -4px;
  right: -6px;
}

.va-tile-pro .va-pro-badge {
  font-size: 8px;
  padding: 3px 6px;
}

.va-tile-label {
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: #193153;
  text-wrap: pretty;
}

/* Bloco largo: texto a esquerda e ilustracao a direita. Ocupa tres colunas no
   desktop e a linha inteira no mobile, como um banner. */
.va-tile-wide {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  min-height: 80px;
  padding: 12px 8px 12px 14px;
  border-radius: 14px;
  background: #f5f6fa;
  cursor: pointer;
  overflow: hidden;
  transition: background-color 0.15s ease;
}

.va-tile-wide:hover {
  background: #eef0f5;
}

/* O texto manda: nunca encolhe abaixo da palavra mais longa (sem min-width: 0)
   e nunca quebra dentro da palavra. Quem cede espaco e a ilustracao. */
.va-tile-wide-label {
  flex: 1 1 auto;
  font-size: 13px;
  line-height: 17px;
  color: #193153;
  overflow-wrap: normal;
  word-break: normal;
  hyphens: manual;
  text-wrap: pretty;
}

/* Horizontal: ate 200px, encolhendo ate 96px se a coluna apertar. */
.va-tile-wide-art {
  flex: 0 1 200px;
  min-width: 96px;
  max-width: 200px;
  height: auto;
  object-fit: contain;
  display: block;
}

/* Banner de linha inteira (mobile): texto maior, ilustracao um pouco menor. */
.va-tile-wide-banner {
  padding: 14px 10px 14px 16px;
}

.va-tile-wide-banner .va-tile-wide-label {
  font-size: 16px;
  line-height: 22px;
}

.va-tile-wide-banner .va-tile-wide-art {
  flex: 0 1 150px;
  max-width: 150px;
}

</style>

<script>
import ProBadge from "@/components/ProBadge.vue";
import sectionsEnum from "@/constants/sections.enum.js";

export default {
  name: "SectionTile",
  components: {
    "vetalfa-pro-badge": ProBadge,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    /** Selo PRO: já resolvido pelo pai (`!isPremium && section.pro`). */
    showPro: {
      type: Boolean,
      default: false,
    },
    /** Bloco largo com ilustração. */
    wide: {
      type: Boolean,
      default: false,
    },
    /** Quantas colunas da grade o bloco largo ocupa. */
    span: {
      type: Number,
      default: 2,
    },
    /** Banner de linha inteira (mobile): fonte maior, ilustracao menor. */
    banner: {
      type: Boolean,
      default: false,
    },
    /** Caminho da ilustração servida de `public/img`. */
    illustration: {
      type: String,
      default: null,
    },
  },
  computed: {
    label() {
      return sectionsEnum.getSectionLabel(this.section);
    },
  },
  data() {
    return {
      illustrationFailed: false,
    };
  },
};
</script>
